<span matSnackBarLabel>{{'updater.new-version' | translate}}</span>
<span matSnackBarActions>
  <button class="pm-action-button" mat-button matSnackBarAction (click)="matSnackBarRef?.dismissWithAction()">{{ 'updater.new-version.refresh-button' | translate }}</button>
  <button class="pm-action-button" mat-button matSnackBarAction (click)="matSnackBarRef?.dismiss()">{{ 'button.close' | translate }}</button>
</span>
